import React, { useEffect, useState } from "react";
import "./BattleCard.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";
import { useDispatch, useSelector } from "react-redux";
import { fetchBattleCardRequest } from "../../../../../store/features/actions/opportunities/battleCardActions";
import { useParams } from "react-router-dom";
import { ValueSellingFrameworkPlaceholder } from "./ValueSellingFramworkPlaceholder";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import GeneratingLoader from "../../../genericComponents/uiElements/GeneratingLoader";
import ExpandableParagraph from "./expandableParagraph/ExpandableParagraph";
import ExpandableList from "./expandableParagraph/ExpandableList";

export default function BattleCardV2({ opportunityId, mainSignal, relevanceScore,mappedProducts , opportunityDescription, oppLvlUnmetNeed, oppLvlSubsignal,whatIsThisOpp,oppLvlBu }) {
  console.log("whatIsThisOpp1",whatIsThisOpp)
  const dispatch = useDispatch();
  const [result, setResult] = useState(null);
  const { clientName } = useParams();
  const { getTaskStatus } = useTaskStatus();

  const { battleCardData, battleCardLoading, error } = useSelector(
    (state) => state?.battleCardReducer
  );

  const taskStatus = getTaskStatus(`opp_sidecard_battle_card_${opportunityId}`);

  const replaceKeyName = (key) => {
    const map = {
      opportunity_details: "What is this Opportunity ?",
      opportunity_where: "Where is this Opportunity ?",
      offerings_to_pitch: `${clientName} Offerings to Pitch`,
      objections_and_competitive_view: "Objections & Competitive View",
    };
    return map[key] || key.replace(/[_\[\]]/g, " ")
                          .replace(/\s+/g, " ")
                          .trim()
                          .replace(/\b\w/g, char => char.toUpperCase());
  };

  const processData = (data) => {
    const transform = (obj) => {
      console.log(" whatIsThisOpp",obj)
      if (Array.isArray(obj)) return obj?.map(transform);
      if (typeof obj === "object" && obj !== null) {
       
        return Object.entries(obj)?.reduce((acc, [key, val]) => {
          if (key === "_id" || key=="id") {
            console.log("processData acc",acc)
            return acc;
           }
          acc[key === "question" ? "" : key === "answer" ? "" : key] = transform(val);
          return acc;
        }, {});
      }
      return obj;
    };

    return {
     
      what_to_speak: {
         ...(false && {
          business_unit: transform(oppLvlBu)
        }),
        ...(mainSignal?.length > 0 && {
          signal: transform(mainSignal)
        }),
        ...(data?.sub_signal?.length > 0 && {
          sub_signal: transform(oppLvlSubsignal || data?.sub_signal)
        }),
        ...(opportunityDescription?.length > 0 && {
          opportunity_description: transform(opportunityDescription)
        }),
        unmet_need: transform(oppLvlUnmetNeed || data.unmet_need),
        ...(mappedProducts?.length > 0 && {
          relevant_offerings: transform(typeof mappedProducts === "string" ? mappedProducts : mappedProducts.join(", "))
        }),
        elevator_pitch: transform(data.elevator_pitch),
        objection: transform(data.objection),
      },
      who_to_speak: {
        opportunity_where: transform(data?.opportunity_where),
        // contact_persona: transform(data.contact_persona),
      },
      competitors: transform(data.competitors),
      ...(whatIsThisOpp ? {
          what_is_the_opportunity: transform(whatIsThisOpp)
        } : {}),
    };
  };

  useEffect(() => {
    if (taskStatus === "completed" || opportunityId) {
      dispatch(fetchBattleCardRequest({ opportunityId }));
    }
  }, [taskStatus, opportunityId]);

  useEffect(() => {
    if (battleCardData) {
      const processed = processData({ ...battleCardData });
      setResult(processed);
    }
  }, [battleCardData]);

  // console.log("battleCardData",battleCardData)

  const renderValue = (value, key = null) => {
    // console.log("renderValue key",key)
    const formatKey = (k) => {
      const mapp= {
        opportunity_where : "",
        unmet_need:"Unmet Need / Pain Point",
        objection:"Most Likely Objection",
        rebuttal:""
      }
      if (mapp?.[k]) {
        return mapp?.[k]
      }
      return k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())};

    if (typeof value === "string") {
      const content = key === "main_signal" && mainSignal ? mainSignal : 
                      key === "relevance_score" && relevanceScore ? `${relevanceScore}%` : value;

      return (
        <div key={key || value} style={{display:"flex", flexDirection:"row"}}>

          {key!="rebuttal" ? <>
          {key && <span style={{ minWidth:"7rem" , maxWidth:"7rem", wordBreak:"break-word", marginBottom:"15px" }} > <strong >{formatKey(key)}: </strong></span>}
          <div  style={{ marginLeft:"0.2rem"}}>
            {
              key == "opportunity_description" ? <p ><ExpandableParagraph text={content} wordLimit={25} /></p> :  <p>{content}</p>
            }
            
          
          </div>
           </>:<>
         
          <div  style={{ marginLeft:"0.2rem"}}>
            {/* <p ><ExpandableParagraph text={content} wordLimit={25} /></p> */}
            <p><span className="opp_bat_span" ><span style={{fontWeight:"500"}}>{formatKey(key)} :  </span></span>{" "}{content}</p>
          </div>
           </>}
        </div>
       
      );
    }

    if (Array.isArray(value)) {
      const hasObj = value.some((v) => typeof v === "object" && v !== null);
      let isCustomRender = false;
      value.forEach((valueItem)=>{
        if(Object(valueItem).hasOwnProperty("signal") || Object(valueItem).hasOwnProperty("source") || Object(valueItem).hasOwnProperty("date")){
          isCustomRender=true;
        }else{
         isCustomRender =  false
        }
      })
      return (
        <div key={key} className="battleCardListTop" style={{display:"flex", flexDirection:"row" }}>
          {key &&<strong style={{ minWidth:"7rem" , maxWidth:"7rem"}}>{formatKey(key)}: </strong>}
          <ul className={`battleCardListUl  col-md-10"`}>
            {key === "sub_signal" ? (
              <ExpandableList items={value} renderItem={renderValue} visibleCount={1} isCustom={isCustomRender?true:false} />
            ) : (
              value.map((item, idx) => <li key={idx}>{renderValue(item)}</li>)
            )}
          </ul>
        </div>
      );
    }

    if (typeof value === "object") {
      return (
        <div key={key} style={{display:"flex", flexDirection:"row"}}>
          {key && key!=="opportunity_where"&& <strong style={{ minWidth:"7rem" , maxWidth:"7rem"}}>{formatKey(key)}: </strong>}
          <div >
            {Object.entries(value).map(([childKey, childVal]) => renderValue(childVal, childKey))}
          </div>
        </div>
      );
    }

    return <div key={key}>{key && <strong>{formatKey(key)}: </strong>}{String(value)}</div>;
  };

  const generateCardContent = (content) =>
    typeof content === "string" ? <div>{content}</div> : renderValue(content);

  if (taskStatus === "pending") {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <GeneratingLoader />
      </div>
    );
  }
const generateCompetitor = (value) => {
  if (!Array.isArray(value)) return "";
  // console.log("value", value);
  return value.map((val) => (
    <>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div style={{ minWidth: "7rem", maxWidth: "7rem" }}>
          <strong>{val?.name}</strong>
        </div>
        <div>
          <div>
            <span style={{ fontWeight: "500" }}>Attack : </span>
            {val?.attack}
          </div>
          <div>
            <span style={{ fontWeight: "500" }}>Avoid : </span>
            {val?.avoid}
          </div>
        </div>
      </div>
      <br />
    </>
  ));
};


// console.log("battleCardData",battleCardData)

if (!battleCardData) {
  return  <div className="no-data-message">
          <NoDataComp
            message="Content is being generated"
            buttonText="Refresh"
            onButtonClick={() => dispatch(fetchBattleCardRequest({ opportunityId }))}
          />
        </div>
}

  return (
    <div className="battlecard_wrapper">
      {battleCardLoading || result === null ? (
        <div className="row w-100">
          <ValueSellingFrameworkPlaceholder numberOfCards={8} widthClass="col-md-12" />
        </div>
      ) : ((battleCardData==undefined || battleCardData?.length==0) && Object.keys(battleCardData)?.length === 0) ? (
        <div className="no-data-message">
          <NoDataComp
            message="Content is being generated"
            buttonText="Refresh"
            onButtonClick={() => dispatch(fetchBattleCardRequest({ opportunityId }))}
          />
        </div>
      ) : (
        <div className="row">
        
            <div className="col-md-12">
              {Object.entries(result)
                .map(([key, value]) => (
                  <div key={key} className="battle_card_block">
                    {key !="competitors"?<ThemedCardComponent
                      title={replaceKeyName(key)}
                      description={generateCardContent(value)}
                    />:<ThemedCardComponent
                      title={replaceKeyName(key)}
                      description={generateCompetitor(value)}
                     
                    />}
                  </div>
                ))}
            </div>
          
        </div>
      )}
    </div>
  );
}
